import { ImageBlock } from "../components/image-block/ImageBlock";
import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

export interface ContentfulImageBlockProps {
  __typename: string;
  image: VinoDataImage;
  caption?: string;
}

const test = ({ __typename }: ContentfulImageBlockProps): boolean =>
  __typename === "VinoData_ImageBlock";

const create = (data: ContentfulImageBlockProps): JSX.Element => {
  const transformedData = {
    ...data,
    image: generateStorefrontImage(data.image),
  };

  return <ImageBlock {...transformedData} />;
};

export default { test, create };
